import { Box, Typography, TextField, IconButton, Paper, InputAdornment, CircularProgress } from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import ButtonTheme from "../ThemeButton/ThemeButton";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";
import MyTable from "../Schedule/MyTable";
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';

export default function UpdateModal({
    close, handleClose, dataLoad
}) {
    // const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("")
    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);
    const [changedSeniorities, setChangedSeniorities] = useState([]);

    const loadData = () => {
        setLoading(true);
        ApiService.get('/getSeniorityEmployee')
            .then(({ data }) => {
                const sortedData = data?.data
                    ?.sort((a, b) => (a.employee?.EHd_Seniority || 0) - (b.employee?.EHd_Seniority || 0))
                    ?.map((item, index) => ({
                        ...item,
                        id: index + 1,
                    }));
                setData(sortedData);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                toast.error(e.message)
                // enqueueSnackbar('Error', { variant: 'error' });
            });
    };

    useEffect(() => {
        loadData()
    }, [])

    const columns = [
        {
            style: { fontSize: 14 },
            field: 'name',
            headerName: 'Members',
            width: 250,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Typography key={1} fontSize={16} style={{ marginLeft: '10px' }}>
                        {params?.row?.EA_Rank} {params?.row?.employee?.fullName}
                    </Typography>
                );
            }
        },
        {
            style: { fontSize: 14 },
            field: 'badge',
            headerName: 'Badge',
            width: 120,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Typography key={1} fontSize={16} style={{ marginLeft: '10px' }}>
                        {params?.row?.employee?.Badge_Number}
                    </Typography>
                );
            }
        },
        {
            style: { fontSize: 14 },
            field: 'Current Seniority',
            headerName: 'Current Seniority',
            width: 170,
            sortable: false,
            renderCell: (params) => (
                `${params?.row?.employee?.EHd_Seniority}`
            )
        },
        {
            style: { fontSize: 14 },
            field: 'Updated Seniority',
            headerName: 'Updated Seniority',
            width: 130,
            sortable: false,
            renderCell: (params) => {
                const empCode = params?.row?.employee?.Emp_Code;
                const existingChange = changedSeniorities.find(entry => entry.emp_code === empCode);
                const inputValue = existingChange?.seniority ?? params?.row?.employee?.EHd_Seniority;

                return (
                    <input
                        type="number"
                        defaultValue={inputValue}
                        step="0.1"
                        onChange={(e) => handleSeniorityChange(e.target.value, params.row)}
                        style={{
                            width: '100%',
                            fontSize: 14,
                            padding: '4px 8px',
                            border: '1px solid #ccc',
                            borderRadius: 4
                        }}
                    />
                );
            }
        }
    ]

    const handleSeniorityChange = useMemo(() =>
        debounce((value, row) => {
            const updatedValue = Number(value);
            const empCode = row?.employee?.Emp_Code;
            if (!empCode) return;

            // const originalValue = row?.originalSeniority ?? row?.employee?.EHd_Seniority;
            // if (updatedValue === originalValue) {
            //     setChangedSeniorities((prev = []) =>
            //         prev.filter(entry => entry.emp_code !== empCode)
            //     );
            //     return;
            // }

            setChangedSeniorities((prev = []) => {
                const exists = prev.find(entry => entry.emp_code === empCode);
                if (exists) {
                    return prev.map(entry =>
                        entry.emp_code === empCode ? { ...entry, seniority: updatedValue } : entry
                    );
                } else {
                    return [...prev, { emp_code: empCode, seniority: updatedValue }];
                }
            });
        }), [setChangedSeniorities]
    );

    const updateMultiSeniority = () => {
        const hasInvalidValue = changedSeniorities.some(entry =>
            entry.seniority === null ||
            entry.seniority === undefined ||
            entry.seniority === ''
        );

        if (hasInvalidValue) {
            toast.error("Seniority value must not be null or empty.")
            // enqueueSnackbar("Seniority value must not be null or empty.", { variant: "error" });
            return;
        }

        ApiService.post("/update-multiple-seniority", {
            seniority_array: changedSeniorities
        }).then((data) => {
            loadData();
            setChangedSeniorities([]);
            toast.success(data.message)
            // enqueueSnackbar(data.message, { variant: "success" });
            handleClose();
            dataLoad();
        }).catch((e) => {
            toast.error(e.data.message)
            // enqueueSnackbar(e?.message, { variant: "error" });
        });
    };

    const filteredData = data.filter((rowsData) =>
        (rowsData?.employee?.fullName || '').toLowerCase().includes(search.toLowerCase())
    );


    return (
        <Box className="p-2">
            <>
                <Row>
                    <Col md={11}>
                        <Typography fontWeight={700} fontSize={21} className="mb-3">Update Seniority</Typography>
                    </Col>
                    <Col md={1}>
                        <img src='/images/close-icon.svg' onClick={close} style={{ cursor: 'pointer', height: 25 }} />
                    </Col>
                </Row>
                <Row className='px-3 mb-2'>
                    <TextField
                        variant="outlined"
                        placeholder="Search by Name"
                        className="mt-0 w-100"
                        color='secondary'
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx: {
                                height: '48px',
                                fontSize: '14px'
                            },
                        }}
                    />
                </Row>
                {loading &&
                    <Box className="w-100 h-100 d-flex justify-content-center align-items-center mt-4">
                        <CircularProgress />
                    </Box>
                }

                {!loading && (
                    data && data.length > 0 ?
                        <div className='rounded-2' style={{ maxHeight: '65vh', overflow: 'scroll', scrollbarWidth: 'none', border: '1px solid #cccccc' }}>
                            <MyTable
                                rows={filteredData}
                                columns={columns}
                                checkboxSelection={false}
                                rowCount={filteredData.length}
                                perPage={100}
                            />
                        </div>
                        :
                        <Typography fontWeight={700} fontSize={16} className="my-4">No results found</Typography>
                )}

                <ButtonTheme disabled={changedSeniorities.length === 0} type='submit' variant="filled" color='primary' className='px-5 mt-4'
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    Update
                </ButtonTheme>

                <Modal show={open} onHide={() => { setOpen(false) }} style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Seniority Update?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-2 mb-1' onClick={() => { setOpen(false) }}>
                                    Cancel
                                </ButtonTheme>
                            </Col>
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-2 mb-1' onClick={updateMultiSeniority}>
                                    Yes
                                </ButtonTheme>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        </Box>
    );
}
